import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { initializeIcons } from '@assets/fa-icons/fa-icons';
// // PROJECTS MODULES
import { appInitializerFactory, CoreModule, HttpLoaderFactory, ToolkitModule } from '@core';
// // CONFIGS
import { environment } from '@env/environment';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ModalsModule } from '@modals/modals.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { SecurityModule } from '@security/security.module';
import { getDatepickerConfig } from '@shared/configs/datepicker.configs';
import { SharedCommonModule } from '@shared/shared-common.module';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppRoutingModule } from './app-routing.module';
// // COMPONENTS
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { IndexComponent } from './pages/index/index.component';


@NgModule({
  declarations: [
    AppComponent,
    IndexComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SecurityModule,
    CoreModule.forRoot({environment}),
    ToolkitModule.forRoot(),
    AppRoutingModule,
    SharedCommonModule,
    LayoutModule,
    ModalsModule
  ],
  providers: [
    {
      provide: BsDatepickerConfig,
      useFactory: getDatepickerConfig,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    initializeIcons(library);
  }
 }
